// Package export.v3 defines the protocol buffer messages and services for exporting data
// from the platform.

// @generated by protoc-gen-es v2.2.5 with parameter "target=ts"
// @generated from file export/v3/export_service.proto (package export.v3, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { RichText } from "../../chat/v3/chat_rich_text_pb";
import { file_chat_v3_chat_rich_text } from "../../chat/v3/chat_rich_text_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file export/v3/export_service.proto.
 */
export const file_export_v3_export_service: GenFile = /*@__PURE__*/
  fileDesc("Ch5leHBvcnQvdjMvZXhwb3J0X3NlcnZpY2UucHJvdG8SCWV4cG9ydC52MyJ4ChVFeHBvcnRSaWNoVGV4dFJlcXVlc3QSJAoJcmljaF90ZXh0GAEgASgLMhEuY2hhdC52My5SaWNoVGV4dBInCgZmb3JtYXQYAiABKA4yFy5leHBvcnQudjMuRXhwb3J0Rm9ybWF0EhAKCGZpbGVuYW1lGAMgASgJImYKFkV4cG9ydFJpY2hUZXh0UmVzcG9uc2USEQoJZmlsZV9kYXRhGAEgASgMEhAKCGZpbGVuYW1lGAIgASgJEhQKDGNvbnRlbnRfdHlwZRgDIAEoCRIRCglmaWxlX3NpemUYBCABKAMqRAoMRXhwb3J0Rm9ybWF0Eh0KGUVYUE9SVF9GT1JNQVRfVU5TUEVDSUZJRUQQABIVChFFWFBPUlRfRk9STUFUX1BERhABMmgKDUV4cG9ydFNlcnZpY2USVwoORXhwb3J0UmljaFRleHQSIC5leHBvcnQudjMuRXhwb3J0UmljaFRleHRSZXF1ZXN0GiEuZXhwb3J0LnYzLkV4cG9ydFJpY2hUZXh0UmVzcG9uc2UiAEJbWllnaXRodWIuY29tL1N0b3J5dGVsbC1haS9zdG9yeXRlbGwtYWktcGxhdGZvcm0vcGtnL2dvL2RvbWFpbnMvY3AvZ2VuL3BiL2V4cG9ydC92MztleHBvcnRWM2IGcHJvdG8z", [file_chat_v3_chat_rich_text]);

/**
 * @generated from message export.v3.ExportRichTextRequest
 */
export type ExportRichTextRequest = Message<"export.v3.ExportRichTextRequest"> & {
  /**
   * @generated from field: chat.v3.RichText rich_text = 1;
   */
  richText: RichText;

  /**
   * @generated from field: export.v3.ExportFormat format = 2;
   */
  format: ExportFormat;

  /**
   * @generated from field: string filename = 3;
   */
  filename: string;
};

/**
 * Describes the message export.v3.ExportRichTextRequest.
 * Use `create(ExportRichTextRequestSchema)` to create a new message.
 */
export const ExportRichTextRequestSchema: GenMessage<ExportRichTextRequest> = /*@__PURE__*/
  messageDesc(file_export_v3_export_service, 0);

/**
 * @generated from message export.v3.ExportRichTextResponse
 */
export type ExportRichTextResponse = Message<"export.v3.ExportRichTextResponse"> & {
  /**
   * @generated from field: bytes file_data = 1;
   */
  fileData: Uint8Array;

  /**
   * @generated from field: string filename = 2;
   */
  filename: string;

  /**
   * @generated from field: string content_type = 3;
   */
  contentType: string;

  /**
   * @generated from field: int64 file_size = 4;
   */
  fileSize: bigint;
};

/**
 * Describes the message export.v3.ExportRichTextResponse.
 * Use `create(ExportRichTextResponseSchema)` to create a new message.
 */
export const ExportRichTextResponseSchema: GenMessage<ExportRichTextResponse> = /*@__PURE__*/
  messageDesc(file_export_v3_export_service, 1);

/**
 * @generated from enum export.v3.ExportFormat
 */
export enum ExportFormat {
  /**
   * @generated from enum value: EXPORT_FORMAT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: EXPORT_FORMAT_PDF = 1;
   */
  PDF = 1,
}

/**
 * Describes the enum export.v3.ExportFormat.
 */
export const ExportFormatSchema: GenEnum<ExportFormat> = /*@__PURE__*/
  enumDesc(file_export_v3_export_service, 0);

/**
 * @generated from service export.v3.ExportService
 */
export const ExportService: GenService<{
  /**
   * @generated from rpc export.v3.ExportService.ExportRichText
   */
  exportRichText: {
    methodKind: "unary";
    input: typeof ExportRichTextRequestSchema;
    output: typeof ExportRichTextResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_export_v3_export_service, 0);

